import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";
import { colors } from "../colors"
import mq from "../mediaQuery";

export const InformationModalStyles: { [key: string]: InterpolationWithTheme<any> } = {
    modal: {
        width: "580px !important"
    },
    container: {
        display: "flex",
        alignItems: "center"
    },
    imgContainer: {
        flex: 1,
        marginRight: "30px",
        [mq[0]]: {
            marginRight: "15px"
        }
    },
    image: {
        width: "35px",
        display: "block",
        marginRight: "15px",
        [mq[0]]: {
            width: "35px"
        }
    },
    textBodyContainer: {
        flex: 3
    },
    textHeader: {
        paddingBottom: "20px",
        display: "flex",
        color: "rgba(0, 0, 0, 0.85)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "24px",
        fontWeight: "bold",
    },
    textBody: {
        color: "rgb(72, 72, 72)",
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: "16px",
        fontWeight: "normal"
    },
    list: {
        color: "rgb(102, 102, 102)",
        padding: "15px",
        listStyle: "none"
    },
    anchor: {
        color: colors.coolBlue
    },
    primaryCta: {
        marginRight: "20px",
        fontSize: "13px",
        width: "180px",
        height: "40px",
        color: colors.white,
        minHeight: "31px",
        borderRadius: "31px",
        background: "#e4306e",
        border: "none",
        cursor: "pointer",
        [mq[0]]: {
            width: "100px"
        }
    },
    secondaryCta: {
        color: colors.darkPink,
        fontSize: "12px",
        cursor: "pointer",
        border: "1px solid #e4306e",
        padding: "12px 35px",
        borderRadius: "30px"
    },
    loader: {
        width: 60,
        height: 60
    },
    bullet: {
        display: "inline-block",
        height: "6px",
        width: "6px",
        background: "red",
        marginRight: "15px",
        borderRadius: "50%"
    },
    listItems: {
        margin: "5px 0px",
        color: "rgb(72, 72, 72)",
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: "14px",
        fontWeight: "normal"
    },
    ctaContainer: {
        textAlign: "right"
    }
}